import { render, staticRenderFns } from "./BGD.vue?vue&type=template&id=1e1c7f61&scoped=true&"
import script from "./BGD.vue?vue&type=script&lang=js&"
export * from "./BGD.vue?vue&type=script&lang=js&"
import style0 from "./BGD.vue?vue&type=style&index=0&id=1e1c7f61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1c7f61",
  null
  
)

export default component.exports